import { Ref, ref } from 'vue';

type SortOrder = 'ASC' | 'DESC';
export interface PaginationParameters<PagedType> {
  sort?: `${string & keyof PagedType},${SortOrder}`;
  page: number;
  size: number;
}

export function usePagination<PagedType>(initialSortBy?: string & keyof PagedType, initialSortOrder: SortOrder = 'ASC') {
  const queryStringParams = ref<PaginationParameters<PagedType>>({
    page: 0,
    size: 10
  }) as Ref<PaginationParameters<PagedType>>;

  if (initialSortBy) {
    queryStringParams.value.sort = `${initialSortBy},${initialSortOrder}`;
  }

  function setPage(pageNumber: number) {
    queryStringParams.value.page = pageNumber;
  }

  function setPageSize(pageSize: number) {
    queryStringParams.value.size = pageSize;
  }

  function setSort(sortBy: string & keyof PagedType, sortOrder: SortOrder = 'ASC') {
    queryStringParams.value.sort = `${sortBy},${sortOrder}`;
  }

  return {
    queryStringParams,
    setPage,
    setPageSize,
    setSort,
  }
}
